var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4f46e5",
    height: "200px",
    width: "200px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 305.755 305.755",
    xmlSpace: "preserve",
    stroke: "#4f46e5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.464,24.407c-30.023,0-56.214,16.13-70.587,40.146c-14.372-24.016-40.559-40.146-70.581-40.146 C36.846,24.407,0,61.253,0,106.703c0,101.476,132.285,174.646,152.877,174.646c19.961,0,152.878-73.489,152.878-174.646 C305.755,61.253,268.914,24.407,223.464,24.407z M218.702,160.294c-11.904,33.382-42.012,47.387-71.168,37.782 c25.62-17.97,34.933-42.174,38.214-54.812c0.132-0.51-0.14-1.038-0.631-1.227c-0.492-0.189-1.046,0.022-1.29,0.489 c-18.054,34.686-49.767,45.393-62.859,55.549c-13.85,10.744-20.648,23.607-23.695,31.228c-0.271,0.679-0.983,1.074-1.703,0.945 c-0.72-0.129-1.25-0.746-1.269-1.477c-0.17-6.688,1.01-17.126,8.061-27.123c5.264-7.05,12.262-16.866,20.827-20.477 c-15.864-22.066-11.555-58.031,18.045-69.048c34.345-10.234,48.99-28.119,55.229-41.871c1.061-2.339,3.451-3.785,6.015-3.64 c2.564,0.146,4.775,1.852,5.566,4.295C216.007,95.514,226.945,137.183,218.702,160.294z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/sustainability.49e35d65f3300295f3c475dea0d75a78.svg";
export { ForwardRef as ReactComponent };